import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { MessageService } from '../../../services/message-service/message.service';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { Haendler } from '../../stammdaten/haendler/haendler';
import { HaendlerDetailsDialogComponent } from '../../stammdaten/haendler/haendler-details-dialog/haendler-details-dialog.component';
import { GruppeTier } from '../classes/gruppe-tier';

export interface GruppeTierHaendlerAendernDialogInput {
    anzahlTiere: number;
    tiere: GruppeTier[];
}

@Component({
    selector: 'kiene-gruppe-tier-haendler-aendern-dialog',
    templateUrl: './gruppe-tier-haendler-aendern-dialog.component.html',
})
export class GruppeTierHaendlerAendernDialogComponent implements OnInit {
    haendlerList: Haendler[] = [];
    haendlerCtrl = new FormControl<Haendler | null>(null, [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<GruppeTierHaendlerAendernDialogComponent, boolean>,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: GruppeTierHaendlerAendernDialogInput,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.loadHaendler();
    }

    loadHaendler(): void {
        const params = new HttpParams().set('favorit', 1);
        this.api.getAll(this.apiBaseUrl + 'viehhaendler/read_kundenportal.php', params).subscribe({
            next: response => {
                this.haendlerList = response.records ?? [];
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Händler', err);
            },
        });
    }

    haendlerComparator(haendler1: Haendler, haendler2: Haendler): boolean {
        return haendler1 && haendler2
            ? haendler1.viehhaendler_id === haendler2.viehhaendler_id
            : haendler1 === haendler2;
    }

    save(): void {
        const selectedHaendler = this.haendlerCtrl.value;
        if (!selectedHaendler) {
            return;
        }

        // Keep phone behavior identical to desktop: same endpoint and payload shape.
        this.api
            .post(this.apiBaseUrl + 'gruppe_tier/update_viehhaendler.php', {
                viehhaendler_id: selectedHaendler.viehhaendler_id,
                tiere: this.data?.tiere ?? [],
            })
            .subscribe({
                next: () => {
                    this.dialogRef.close(true);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Updaten des Händlers', err);
                },
            });
    }

    openCreateHaendlerDialog(): void {
        const dialogRef = this.dialog.open(HaendlerDetailsDialogComponent);
        dialogRef.afterClosed().subscribe((result: Haendler) => {
            if (result) {
                this.haendlerCtrl.setValue(result);
                this.loadHaendler();
            }
        });
    }
}

